import React from "react";

export const AmexIcon = (props) => (
  <svg
    width="26"
    height="19"
    viewBox="0 0 26 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_14085_125767"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="26"
      height="19"
    >
      <rect width="25.6359" height="17.5789" fill="#016FD0" />
    </mask>
    <g mask="url(#mask0_14085_125767)">
      <rect width="25.6359" height="17.5789" rx="1.46491" fill="#016FD0" />
      <path
        d="M4.98652 13.9484V9.91528H9.25681L9.71497 10.5125L10.1883 9.91528H25.6884V13.6702C25.6884 13.6702 25.283 13.9443 24.8142 13.9484H16.2315L15.7149 13.3126V13.9484H14.0222V12.8631C14.0222 12.8631 13.791 13.0146 13.2911 13.0146H12.715V13.9484H10.1521L9.69455 13.3383L9.23002 13.9484H4.98652Z"
        fill="white"
      />
      <path
        d="M0 6.8756L0.962969 4.63058H2.62832L3.17482 5.88815V4.63058H5.24501L5.57033 5.53952L5.88573 4.63058H15.1787V5.08754C15.1787 5.08754 15.6673 4.63058 16.4701 4.63058L19.4853 4.64112L20.0224 5.88223V4.63058H21.7549L22.2317 5.3435V4.63058H23.98V8.66367H22.2317L21.7747 7.94845V8.66367H19.2294L18.9734 8.02791H18.2891L18.0373 8.66367H16.3112C15.6203 8.66367 15.1787 8.21605 15.1787 8.21605V8.66367H12.5761L12.0595 8.02791V8.66367H2.38161L2.12582 8.02791H1.44373L1.18974 8.66367H0V6.8756Z"
        fill="white"
      />
      <path
        d="M1.30313 5.12766L0.00429916 8.14751H0.849907L1.08956 7.54279H2.48276L2.72117 8.14751H3.58541L2.28781 5.12766H1.30313ZM1.78368 5.83047L2.20834 6.88717H1.35777L1.78368 5.83047Z"
        fill="#016FD0"
      />
      <path
        d="M3.67484 8.1468V5.12695L4.8765 5.13142L5.57542 7.07843L6.25761 5.12695H7.44965V8.1468H6.69469V5.92165L5.89441 8.1468H5.23231L4.4298 5.92165V8.1468H3.67484Z"
        fill="#016FD0"
      />
      <path
        d="M7.96681 8.14683V5.12695H10.4304V5.80245H8.72973V6.31901H10.3907V6.95478H8.72973V7.4912H10.4304V8.14683H7.96681Z"
        fill="#016FD0"
      />
      <path
        d="M10.8668 5.12766V8.14753H11.6218V7.07468H11.9397L12.8449 8.14753H13.7675L12.7741 7.03495C13.1818 7.00055 13.6024 6.65063 13.6024 6.10738C13.6024 5.47189 13.1036 5.12766 12.5469 5.12766H10.8668ZM11.6218 5.80315H12.4848C12.6918 5.80315 12.8424 5.96509 12.8424 6.12104C12.8424 6.32166 12.6473 6.43892 12.496 6.43892H11.6218V5.80315Z"
        fill="#016FD0"
      />
      <path
        d="M14.6825 8.14683H13.9116V5.12695H14.6825V8.14683Z"
        fill="#016FD0"
      />
      <path
        d="M16.5101 8.14683H16.3437C15.5387 8.14683 15.0499 7.51256 15.0499 6.64931C15.0499 5.76473 15.5332 5.12695 16.5499 5.12695H17.3843V5.84219H16.5194C16.1066 5.84219 15.8148 6.16427 15.8148 6.65676C15.8148 7.2416 16.1485 7.48723 16.6293 7.48723H16.828L16.5101 8.14683Z"
        fill="#016FD0"
      />
      <path
        d="M18.1535 5.12766L16.8547 8.14751H17.7003L17.9399 7.54279H19.3331L19.5715 8.14751H20.4358L19.1382 5.12766H18.1535ZM18.634 5.83047L19.0587 6.88717H18.2081L18.634 5.83047Z"
        fill="#016FD0"
      />
      <path
        d="M20.523 8.14683V5.12695H21.4829L22.7085 7.02431V5.12695H23.4635V8.14683H22.5346L21.278 6.19981V8.14683H20.523Z"
        fill="#016FD0"
      />
      <path
        d="M5.5033 13.4319V10.412H7.96689V11.0875H6.26622V11.604H7.92715V12.2398H6.26622V12.7762H7.96689V13.4319H5.5033Z"
        fill="#016FD0"
      />
      <path
        d="M17.5743 13.4319V10.412H20.0379V11.0875H18.3372V11.604H19.9902V12.2398H18.3372V12.7762H20.0379V13.4319H17.5743Z"
        fill="#016FD0"
      />
      <path
        d="M8.06275 13.4318L9.26224 11.9405L8.03419 10.412H8.98534L9.71671 11.3569L10.4506 10.412H11.3645L10.1526 11.9219L11.3543 13.4318H10.4033L9.69312 12.5018L9.00024 13.4318H8.06275Z"
        fill="#016FD0"
      />
      <path
        d="M11.4431 10.4124V13.4322H12.2179V12.4786H13.0126C13.6851 12.4786 14.1948 12.1218 14.1948 11.4281C14.1948 10.8534 13.795 10.4124 13.1107 10.4124H11.4431ZM12.2179 11.0953H13.0549C13.2721 11.0953 13.4274 11.2284 13.4274 11.443C13.4274 11.6445 13.2729 11.7907 13.0524 11.7907H12.2179V11.0953Z"
        fill="#016FD0"
      />
      <path
        d="M14.523 10.412V13.4319H15.278V12.359H15.5959L16.5011 13.4319H17.4237L16.4303 12.3193C16.838 12.2849 17.2586 11.935 17.2586 11.3917C17.2586 10.7562 16.7598 10.412 16.2031 10.412H14.523ZM15.278 11.0875H16.141C16.348 11.0875 16.4986 11.2494 16.4986 11.4054C16.4986 11.606 16.3035 11.7233 16.1522 11.7233H15.278V11.0875Z"
        fill="#016FD0"
      />
      <path
        d="M20.3881 13.4319V12.7762H21.899C22.1226 12.7762 22.2194 12.6554 22.2194 12.5229C22.2194 12.396 22.1229 12.2676 21.899 12.2676H21.2163C20.6228 12.2676 20.2923 11.906 20.2923 11.3632C20.2923 10.8789 20.5949 10.412 21.4769 10.412H22.9471L22.6292 11.0915H21.3577C21.1146 11.0915 21.0398 11.219 21.0398 11.3408C21.0398 11.466 21.1322 11.604 21.3179 11.604H22.0332C22.6947 11.604 22.9818 11.9793 22.9818 12.4708C22.9818 12.9991 22.6619 13.4319 21.9971 13.4319H20.3881Z"
        fill="#016FD0"
      />
      <path
        d="M23.1584 13.4319V12.7762H24.6693C24.8929 12.7762 24.9897 12.6554 24.9897 12.5229C24.9897 12.396 24.8932 12.2676 24.6693 12.2676H23.9866C23.3931 12.2676 23.0625 11.906 23.0625 11.3632C23.0625 10.8789 23.3652 10.412 24.2471 10.412H25.6873L25.3995 11.0915H24.1279C23.8849 11.0915 23.8101 11.219 23.8101 11.3408C23.8101 11.466 23.9025 11.604 24.0882 11.604H24.8034C25.465 11.604 25.7521 11.9793 25.7521 12.4708C25.7521 12.9991 25.4322 13.4319 24.7674 13.4319H23.1584Z"
        fill="#016FD0"
      />
    </g>
  </svg>
);

export const MastercardIcon = (props) => (
  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="25.6359" height="17.5789" rx="1.46491" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0011 12.5667C12.1283 13.3198 10.9962 13.7745 9.75906 13.7745C6.99868 13.7745 4.76096 11.5108 4.76096 8.71839C4.76096 5.92597 6.99868 3.66226 9.75906 3.66226C10.9962 3.66226 12.1283 4.11693 13.0011 4.8701C13.8738 4.11693 15.006 3.66226 16.2431 3.66226C19.0035 3.66226 21.2412 5.92597 21.2412 8.71839C21.2412 11.5108 19.0035 13.7745 16.2431 13.7745C15.006 13.7745 13.8738 13.3198 13.0011 12.5667Z"
      fill="#ED0006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0011 12.5667C14.0757 11.6393 14.7572 10.2593 14.7572 8.71839C14.7572 7.17744 14.0757 5.79749 13.0011 4.8701C13.8738 4.11693 15.006 3.66226 16.2431 3.66226C19.0035 3.66226 21.2412 5.92597 21.2412 8.71839C21.2412 11.5108 19.0035 13.7745 16.2431 13.7745C15.006 13.7745 13.8738 13.3198 13.0011 12.5667Z"
      fill="#F9A000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0011 4.87012C14.0757 5.7975 14.7572 7.17744 14.7572 8.71839C14.7572 10.2593 14.0757 11.6393 13.0011 12.5667C11.9265 11.6393 11.245 10.2593 11.245 8.71838C11.245 7.17744 11.9265 5.7975 13.0011 4.87012Z"
      fill="#FF5E00"
    />
  </svg>
);

export const VisaIcon = (props) => (
  <svg
    width="27"
    height="19"
    viewBox="0 0 27 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.25"
      y="0.25"
      width="26.1359"
      height="18.0789"
      rx="1.71491"
      fill="white"
      stroke="#E5E5E5"
      strokeWidth="0.5"
    />
    <path
      d="M11.4679 12.2799H10.0183L10.925 6.67401H12.3744L11.4679 12.2799Z"
      fill="#142EBD"
    />
    <path
      d="M16.7219 6.81111C16.436 6.69769 15.9826 6.57245 15.4218 6.57245C13.9904 6.57245 12.9824 7.33577 12.9762 8.42708C12.9643 9.23226 13.6979 9.67947 14.2466 9.94794C14.8074 10.2223 14.998 10.4013 14.998 10.6459C14.9923 11.0214 14.5448 11.1945 14.1275 11.1945C13.5488 11.1945 13.2387 11.1053 12.7675 10.8963L12.5766 10.8068L12.3738 12.0652C12.7138 12.2201 13.3401 12.3575 13.9904 12.3635C15.5113 12.3635 16.5015 11.612 16.5132 10.449C16.519 9.81089 16.1316 9.3219 15.2965 8.92233C14.7895 8.66583 14.4791 8.49287 14.4791 8.23043C14.485 7.99184 14.7417 7.74747 15.314 7.74747C15.7852 7.7355 16.1314 7.84877 16.3937 7.96212L16.5248 8.02165L16.7219 6.81111Z"
      fill="#142EBD"
    />
    <path
      d="M18.6492 10.294C18.7686 9.9719 19.2279 8.72546 19.2279 8.72546C19.2219 8.73743 19.3471 8.39746 19.4186 8.18876L19.5199 8.6718C19.5199 8.6718 19.7944 10.0137 19.854 10.294C19.6275 10.294 18.9355 10.294 18.6492 10.294ZM20.4385 6.67401H19.3173C18.9715 6.67401 18.7088 6.77531 18.5596 7.13914L16.4066 12.2799H17.9275C17.9275 12.2799 18.1779 11.5879 18.2317 11.4389C18.3986 11.4389 19.8781 11.4389 20.0928 11.4389C20.1344 11.6357 20.2657 12.2799 20.2657 12.2799H21.6078L20.4385 6.67401Z"
      fill="#142EBD"
    />
    <path
      d="M8.80749 6.67401L7.38794 10.4967L7.23282 9.72142C6.97037 8.82684 6.14729 7.8549 5.22877 7.37162L6.52903 12.274H8.06185L10.3402 6.67401H8.80749Z"
      fill="#142EBD"
    />
    <path
      d="M6.06978 6.67401H3.73765L3.71379 6.78728C5.533 7.25249 6.73782 8.37384 7.23283 9.72166L6.72585 7.14524C6.64238 6.7872 6.38588 6.68582 6.06978 6.67401Z"
      fill="#142EBD"
    />
  </svg>
);

export const KlarnaIcon = (props) => (
  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="25.6359" height="17.5789" rx="1.46491" fill="#FEB4C7" />
    <path
      d="M3.97282 11.2648H2.92969V6.59204H3.97282V11.2648Z"
      fill="#181818"
    />
    <path
      d="M6.57711 6.59204H5.55659C5.55659 7.45195 5.17203 8.24122 4.50154 8.75758L4.09723 9.06886L5.6638 11.265H6.95182L5.51037 9.24422C6.19364 8.54473 6.57711 7.60366 6.57711 6.59204Z"
      fill="#181818"
    />
    <path d="M8.24092 11.2636H7.2558V6.59294H8.24092V11.2636Z" fill="#181818" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2173 8.0327V8.23937C10.9515 8.05295 10.6306 7.94339 10.2846 7.94339C9.36878 7.94339 8.62636 8.70666 8.62636 9.64819C8.62636 10.5897 9.36878 11.353 10.2846 11.353C10.6306 11.353 10.9515 11.2434 11.2173 11.0571V11.2635H12.1582V8.0327H11.2173ZM11.2144 9.64821C11.2144 10.1073 10.8327 10.4795 10.3618 10.4795C9.891 10.4795 9.50927 10.1073 9.50927 9.64821C9.50927 9.18912 9.891 8.81703 10.3618 8.81703C10.8327 8.81703 11.2144 9.18912 11.2144 9.64821Z"
      fill="#181818"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1437 8.23937V8.0327H22.0846V11.2635H21.1437V11.0571C20.8779 11.2434 20.5571 11.353 20.211 11.353C19.2952 11.353 18.5527 10.5897 18.5527 9.64819C18.5527 8.70666 19.2952 7.94339 20.211 7.94339C20.5571 7.94339 20.8779 8.05295 21.1437 8.23937ZM20.2882 10.4795C20.7591 10.4795 21.1408 10.1073 21.1408 9.64821C21.1408 9.18912 20.7591 8.81703 20.2882 8.81703C19.8174 8.81703 19.4357 9.18912 19.4357 9.64821C19.4357 10.1073 19.8174 10.4795 20.2882 10.4795Z"
      fill="#181818"
    />
    <path
      d="M16.8808 7.9458C16.5049 7.9458 16.1492 8.06576 15.9114 8.39674V8.03289H14.9745V11.2636H15.9229V9.56572C15.9229 9.07442 16.2433 8.83383 16.6292 8.83383C17.0427 8.83383 17.2804 9.0878 17.2804 9.55904V11.2636H18.2202V9.20899C18.2202 8.45712 17.6388 7.9458 16.8808 7.9458Z"
      fill="#181818"
    />
    <path
      d="M13.6137 8.03275V8.45355C13.8024 8.20114 14.1538 8.03294 14.5359 8.03294V8.97307L14.5329 8.97297L14.5286 8.97275L14.5247 8.97264C14.1524 8.97264 13.6159 9.2462 13.6159 9.75512V11.2636H12.6504V8.03275H13.6137Z"
      fill="#181818"
    />
    <path
      d="M22.493 10.7247C22.493 10.3894 22.7573 10.1176 23.0834 10.1176C23.4095 10.1176 23.6739 10.3894 23.6739 10.7247C23.6739 11.0599 23.4095 11.3317 23.0834 11.3317C22.7573 11.3317 22.493 11.0599 22.493 10.7247Z"
      fill="#181818"
    />
  </svg>
);

export const CardGeneralIcon = (props) => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.55 4.75313V10.2984C17.55 10.9287 17.2726 11.5332 16.779 11.9789C16.2853 12.4246 15.6157 12.675 14.9175 12.675H2.6325C1.93432 12.675 1.26473 12.4246 0.771041 11.9789C0.277352 11.5332 0 10.9287 0 10.2984V4.75313H17.55ZM14.04 7.92188H11.4075C11.1748 7.92188 10.9516 8.00534 10.787 8.1539C10.6224 8.30247 10.53 8.50396 10.53 8.71406C10.53 8.92416 10.6224 9.12566 10.787 9.27422C10.9516 9.42279 11.1748 9.50625 11.4075 9.50625H14.04C14.2727 9.50625 14.4959 9.42279 14.6605 9.27422C14.825 9.12566 14.9175 8.92416 14.9175 8.71406C14.9175 8.50396 14.825 8.30247 14.6605 8.1539C14.4959 8.00534 14.2727 7.92188 14.04 7.92188ZM14.9175 0C15.6157 0 16.2853 0.250387 16.779 0.696079C17.2726 1.14177 17.55 1.74626 17.55 2.37656V3.16875H0V2.37656C0 1.74626 0.277352 1.14177 0.771041 0.696079C1.26473 0.250387 1.93432 0 2.6325 0H14.9175Z"
      fill="#18181B"
    />
  </svg>
);

export const BankIcon = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0L0 3.33333V4.66667H14V3.33333M10.3158 6V10.6667H12.5263V6M0 14H14V12H0M5.89474 6V10.6667H8.10526V6M1.47368 6V10.6667H3.68421V6H1.47368Z"
      fill="#18181B"
    />
  </svg>
);
